'use client'

import { styled } from 'styled-components'

import { ButtonAsA } from '@b-stock/fe-core/bstock-react'
import {
  Breakpoints,
  Colors,
  Shadows,
  Typography,
} from '@b-stock/fe-core/design-system'

import Image from '@/components/Image'

import { CarouselItemWrapper } from '../common/carousel/Carousel'

export const StyledSection = styled.section`
  background-color: ${Colors.Semantic.Warning.background};
  padding: 3rem 1.5rem;

  @media ${Breakpoints.min.medium} {
    padding: 4rem 3rem;
  }
`

export const Content = styled.div`
  width: 100%;
  max-width: var(--maxPageWidth);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${CarouselItemWrapper} {
    padding: 0 0.3125rem;
  }
`

export const ContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  & > *:first-child {
    margin-right: auto;
  }
`

export const Title = styled.h3`
  ${Typography.Title3};
  color: ${Colors.Semantic.Neutral.light_black};
  padding: 0 0.3125rem;

  @media ${Breakpoints.min.medium} {
    ${Typography.Title2};
  }
`

export const ViewAllSellers = styled(ButtonAsA)`
  ${Typography.Body3_Semibold};
  color: ${Colors.Semantic.Neutral.light_black};
  white-space: nowrap;
  padding: 0;

  &&:hover {
    background-color: transparent;
    color: ${Colors.Semantic.Info.highlight};
  }
`

export const Card = styled.a<{ $bgColor: string }>`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  width: 20rem;
  padding: 2rem;
  border-radius: 1.5rem;
  ${Shadows.MultipleCards};
  background-color: ${({ $bgColor }) =>
    $bgColor || Colors.Semantic.Neutral.white};
  color: ${Colors.Semantic.Neutral.black};
`

export const CardTitle = styled.p`
  ${Typography.Subtitle1};
  color: ${Colors.Semantic.Neutral.black};
`

export const SellerLogo = styled(Image)`
  width: 4.6875rem;
  height: 4.6875rem;

  @media ${Breakpoints.min.medium} {
    width: 5.4375rem;
    height: 5.4375rem;
  }
`
